import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from "react";
import { NavLink } from "..";
import { TypedSecondaryMenuQuery } from "./queries";
import "./scss/index.scss";

var Nav = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Nav, _React$PureComponent);

  function Nav() {
    _classCallCheck(this, Nav);

    return _possibleConstructorReturn(this, _getPrototypeOf(Nav).apply(this, arguments));
  }

  _createClass(Nav, [{
    key: "render",
    value: function render() {
      return React.createElement("footer", {
        className: "footer-nav"
      }, React.createElement("div", {
        className: "container"
      }, React.createElement(TypedSecondaryMenuQuery, null, function (_ref) {
        var data = _ref.data;
        return data.shop.navigation.secondary.items.map(function (item) {
          return React.createElement("div", {
            className: "footer-nav__section",
            key: item.id
          }, React.createElement("h4", {
            className: "footer-nav__section-header"
          }, React.createElement(NavLink, {
            item: item
          })), React.createElement("div", {
            className: "footer-nav__section-content"
          }, item.children.map(function (subItem) {
            return React.createElement("p", {
              key: subItem.id
            }, React.createElement(NavLink, {
              item: subItem
            }));
          })));
        });
      })));
    }
  }]);

  return Nav;
}(React.PureComponent);

export default Nav;